import type { SearchArticleMeta } from "@serophin/nottldr-shared";
import { useEffect, useRef } from "preact/hooks";
import { useAudioPlayer } from "../../contexts/AudioPlayerContext";

/** The articles are the audio player's playlist while the list is on screen; another filter (`resetKey`) or leaving stops what plays. */
export const useAudioPlaylist = (metas: SearchArticleMeta[], resetKey?: string) => {
  const audio = useAudioPlayer();
  const previousKey = useRef(resetKey);

  useEffect(() => {
    audio.setPlaylist(metas);
    if (previousKey.current !== resetKey) {
      audio.pause();
    }
    previousKey.current = resetKey;
  }, [metas, resetKey]);

  useEffect(() => () => audio.pause(), []);
};
